import React from "react"
import ReactDOM from "react-dom"
import "./styles.css"
import "react-colorful/dist/index.css"
import App from "./App"

ReactDOM.render(<App />, document.getElementById("root"))
